import { render, staticRenderFns } from "./MangaRankItem.vue?vue&type=template&id=d64e3b64&"
import script from "./MangaRankItem.vue?vue&type=script&lang=js&"
export * from "./MangaRankItem.vue?vue&type=script&lang=js&"
import style0 from "./MangaRankItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports